import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {FormField} from 'shells/form/form-field';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

import type {GetAvailablePhoneNumbers_availablePhoneNumbers as AvailablePhoneNumber} from 'nutshell-graphql-types';

import {useProvisionPhoneNumber} from '../../graphql/hooks';

import {Header} from './header';

type Props = {
    phoneNumbers: AvailablePhoneNumber[];
    onGenerateNumbers: () => void;
    isGenerating: boolean;
    refetchInboxStatus: () => Promise<any>;
};

export function SelectNumber(props: Props) {
    const [selectedNumber, setSelectedNumber] = React.useState('');
    const [isSaving, setIsSaving] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState<any>(null);

    const {provisionPhoneNumber} = useProvisionPhoneNumber();

    const onSelectNumber = () => {
        setIsSaving(true);
        setErrorMessage(null);

        provisionPhoneNumber({phoneNumber: selectedNumber})
            .then(() => {
                props.refetchInboxStatus();
            })
            .catch(() => {
                setErrorMessage(
                    'An error occurred while saving your phone number. Please try again.'
                );
                setIsSaving(false);
            });
    };

    return (
        <StackLegacy spacing={16}>
            <Header />
            <FormField
                innerId='phoneNumber'
                label='Select your phone number'
                sublabel='Select one of the phone numbers below to use as your company’s primary texting phone number.'
                errorMessage={errorMessage}
            >
                <RadioGroup
                    name='phoneNumber'
                    selectedValue={selectedNumber}
                    onChange={(number) => setSelectedNumber(number)}
                >
                    {props.phoneNumbers.map((option) => (
                        <Radio key={option.number} value={option.e164}>
                            {option.numberFormatted}
                        </Radio>
                    ))}
                </RadioGroup>
            </FormField>
            <div className='flex full-width justify-sb align-center'>
                <Button onClick={props.onGenerateNumbers} size='big' variant='primary'>
                    {props.isGenerating ? 'Generating…' : 'Generate new numbers'}
                </Button>
                <SaveButton
                    isSaving={isSaving}
                    buttonText='Save phone number'
                    savingText='Saving…'
                    disabled={!selectedNumber}
                    // @ts-expect-error
                    onClick={onSelectNumber}
                    resetOnComplete={true}
                />
            </div>
        </StackLegacy>
    );
}
